interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: 'left' | 'center';
}

export default function SectionHeading({ eyebrow, title, desc, align = 'left' }: SectionHeadingProps) {
  const alignment = align === 'center' ? 'items-center text-center' : 'items-start text-left';
  return (
    <div className={`flex w-full flex-col ${alignment} gap-3`}>
      <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1 font-label text-xs font-medium tracking-wide text-primary-700">
        <span className="w-1.5 h-1.5 rounded-full bg-accent-500" />
        {eyebrow}
      </span>
      <h2 className="font-heading text-2xl font-semibold leading-snug text-foreground-950 md:text-3xl">
        {title}
      </h2>
      {desc ? (
        <p className={`text-sm leading-relaxed text-foreground-600 md:text-base ${align === 'center' ? 'max-w-2xl' : 'max-w-3xl'}`}>
          {desc}
        </p>
      ) : null}
    </div>
  );
}